import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AccountService } from 'src/app/services/account.service';
import { CreatorTeamService } from 'src/app/services/creator-team.service';

@Component({
  selector: 'app-follow-btn',
  templateUrl: './follow-btn.component.html',
  styleUrls: ['./follow-btn.component.scss']
})
export class FollowBtnComponent {

  canToggleFollow = true
  follows$: Observable<number[]>;
  isAuthenticated$: Observable<boolean>;

  @Input() creatorTeamId: number;

  @Output() onToggleFollow = new EventEmitter<boolean>();

  @ViewChild('followElement', { static: false }) button: ElementRef;

  constructor(private creatorTeamService: CreatorTeamService,
    private account: AccountService) {
      this.isAuthenticated$ = this.account.isAuthenticated$.pipe(tap(authed => {
        if (authed) {
          this.follows$ = this.creatorTeamService.getMyFollows();
        } else {
          this.follows$ = undefined;
        }
      }));
  }

  toggleFollow(isFollowing: boolean, teamId: number) {
    if (!this.canToggleFollow) {
      return;
    }

    this.canToggleFollow = false;
    setTimeout(() => this.canToggleFollow = true, 1000);

    if (isFollowing) {
      this.creatorTeamService.unfollowTeam(teamId).subscribe();
      this.onToggleFollow.emit(false);
    } else {
      this.creatorTeamService.followTeam(teamId).subscribe();
      this.onToggleFollow.emit(true);
    }
  }

  focusButton() {
    this.button.nativeElement.focus();
  }
}
